export default function TrendChart({ points, label, testid }) {
  const vals = (points || []).map((p) => p.value ?? p.rating).filter((v) => v != null);
  if (vals.length < 2) {
    return <div className="text-xs py-6 text-center" style={{ color: "var(--text-2)" }} data-testid={testid}>Not enough data for a {label} trend yet.</div>;
  }
  const w = 560, h = 120, pad = 10;
  const min = Math.min(...vals) - 0.1, max = Math.max(...vals) + 0.1;
  const xy = vals.map((v, i) => [pad + (i * (w - 2 * pad)) / (vals.length - 1), h - pad - ((v - min) / (max - min)) * (h - 2 * pad)]);
  const d = xy.map(([x, y], i) => `${i ? "L" : "M"}${x.toFixed(1)},${y.toFixed(1)}`).join(" ");
  return (
    <div data-testid={testid}>
      <svg viewBox={`0 0 ${w} ${h}`} className="w-full h-28">
        <path d={d} fill="none" stroke="var(--primary)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
        {xy.map(([x, y], i) => <circle key={i} cx={x} cy={y} r="3" fill="var(--primary)" />)}
      </svg>
      <div className="flex justify-between text-[10px] mono" style={{ color: "var(--text-2)" }}>
        <span>{vals[0].toFixed(2)}</span><span>{label} · {vals.length} points</span><span>{vals[vals.length - 1].toFixed(2)}</span>
      </div>
    </div>
  );
}
